import { PT, connect, React } from '@gasbuddy/react';
import { Grid, Checkbox, Button } from 'semantic-ui-react';

class PayStatus extends React.Component {
  state = {
    isPayAvailable: true,
    mobileEnabled: false,
    ccEnabled: undefined,
  };

  componentDidMount() {
    this.setStateFromProps(this.props);
  }

  componentDidUpdate(prevProps) {
    const { paystatus: newPayStatus } = this.props;
    const { paystatus: prevPayStatus } = prevProps;
    if (
      prevPayStatus.is_pay_available !== newPayStatus.is_pay_available
      || prevPayStatus.mobile_enabled !== newPayStatus.mobile_enabled
      || prevPayStatus.cc_enabled !== newPayStatus.cc_enabled
    ) {
      this.setStateFromProps(this.props);
    }
  }

  setStateFromProps(props) {
    const isPayAvailable = !!props.paystatus?.is_pay_available;
    const mobileEnabled = isPayAvailable && props.paystatus?.mobile_enabled;
    const ccEnabled = props.paystatus?.cc_enabled;
    this.setState({ isPayAvailable, mobileEnabled, ccEnabled });
  }

  togglePay = () => {
    this.setState(prevState => ({
      isPayAvailable: !prevState.isPayAvailable,
      mobileEnabled: (!prevState.isPayAvailable && prevState.mobileEnabled),
    }));
  }

  toggleMobile = () => {
    this.setState(prevState => ({ mobileEnabled: !prevState.mobileEnabled }));
  }

  toggleCcEnabled = () => {
    this.setState(prevState => ({ ccEnabled: !prevState.ccEnabled }));
  }

  save = () => {
    const { saveCallback } = this.props;
    const { isPayAvailable, mobileEnabled, ccEnabled } = this.state;
    saveCallback(
      {
        is_pay_available: isPayAvailable,
        mobile_enabled: mobileEnabled,
        cc_enabled: ccEnabled,
      },
    );
  }

  render() {
    const { isPayAvailable, mobileEnabled, ccEnabled } = this.state;
    const { poi } = this.props;
    return (
      <Grid.Row>
        <Grid.Column width={2}>
          <Checkbox label="Pay Available" onChange={this.togglePay} checked={isPayAvailable} />
        </Grid.Column>
        <Grid.Column width={2}>
          <Checkbox label="Mobile Enabled" onChange={this.toggleMobile} checked={mobileEnabled && isPayAvailable} disabled={!isPayAvailable} />
        </Grid.Column>
        <Grid.Column width={2}>
          <Checkbox
            label="Accepts Credit Cards"
            onChange={this.toggleCcEnabled}
            checked={ccEnabled !== false}
          />
        </Grid.Column>
        <Grid.Column width={1}>
          <Button primary onClick={() => this.save()} loading={poi.loading}>Save Pay Status</Button>
        </Grid.Column>
      </Grid.Row>
    );
  }
}
export const PoiPayStatus = connect(state => state)(PayStatus);

PayStatus.defaultProps = {
  poi: {
    loading: false,
  },
  paystatus: {
    poi_id: 0,
    is_pay_available: true,
    mobile_enabled: false,
    cc_enabled: true,
  },
};

PayStatus.propTypes = {
  poi: PT.shape(
    {
      loading: PT.boolean,
    },
  ),
  paystatus: PT.shape(
    {
      poi_id: PT.number,
      is_pay_available: PT.boolean,
      mobile_enabled: PT.boolean,
      cc_enabled: PT.boolean,
    },
  ),
  saveCallback: PT.func.isRequired,
};
